import { useCallback, useEffect, useState } from "react";

const STORAGE_KEY = "fatura-theme";

/**
 * Estado de tema (light/dark) do Fatura WEB.
 *
 * Aplica `data-theme` no <html> — a paleta dark vem dos tokens da lib
 * (`[data-theme='dark']` em tokens-and-primitives.css). Persiste a escolha
 * em localStorage. Default: light.
 */
export function getInitialTheme() {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === "light" || saved === "dark") return saved;
  } catch (e) {
    /* localStorage indisponível — usa default */
  }
  return "light";
}

export default function useTheme() {
  const [theme, setTheme] = useState(getInitialTheme);

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    try {
      localStorage.setItem(STORAGE_KEY, theme);
    } catch (e) {
      /* ignora falha de persistência */
    }
  }, [theme]);

  const toggleTheme = useCallback(() => {
    setTheme((t) => (t === "dark" ? "light" : "dark"));
  }, []);

  return { theme, toggleTheme, setTheme };
}
